// extracted by mini-css-extract-plugin
export default {"listImageBackgroundColor":"ru-FF","square":"VSrew"};